import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import * as sx from "./no-datasets-message.sx";

export function NoDatasetsMessage() {
  return (
    <sx.NoDatasets>
      <Typography variant="body1">
        <FormattedMessage id="resources.dataset.no-datasets-card.text" />
      </Typography>
    </sx.NoDatasets>
  );
}
